/* global $, jQuery */

/**
 * Client-side filtering for category pages.
 * Filters stone cards by color (or other attributes).
 */
export function initFilters() {
  var $cards = $('.stone-card-wrap');
  var $filters = $('.filter__btn');
  var $grid = $('#stone-grid');
  var $count = $('#results-count');
  var $empty = $('#empty-state');

  $filters.on('click', function () {
    var $btn = $(this);
    var filterType = $btn.data('filter-type');
    var filterValue = $btn.data('filter-value');

    // Update active state for buttons with same filter-type
    $filters.filter('[data-filter-type="' + filterType + '"]')
      .removeClass('filter__btn--active')
      .attr('aria-pressed', 'false');
    $btn.addClass('filter__btn--active').attr('aria-pressed', 'true');

    // Filter cards
    if (filterValue === 'all') {
      $cards.show();
    } else {
      $cards.each(function () {
        var $card = $(this);
        if ($card.data(filterType) === filterValue) {
          $card.show();
        } else {
          $card.hide();
        }
      });
    }

    // Update count and empty state
    var visibleCount = $cards.filter(':visible').length;
    $count.text(visibleCount);

    if (visibleCount === 0) {
      $empty.show();
      $grid.hide();
    } else {
      $empty.hide();
      $grid.show();
    }
  });

  // Reset filters
  $('#reset-filters').on('click', function () {
    $filters.filter('[data-filter-value="all"]').first().trigger('click');
  });

  // Set initial count
  $count.text($cards.length);
}
